import { AuthUtil } from 'src/utils';
import Routes from '../Navigator/Navigator.route';

export const getUserInfo = async (
  response,
  setCookieFn,
  resetErrorMessage,
  history
) => {
  try {
    const authToken = response.data.token;

    await AuthUtil.fetchCurrentUserInfo(authToken, (user) => {
      const expireDate = new Date();
      expireDate.setTime(expireDate.getTime() + 24 * 3600 * 1000);

      const {
        spouse,
        guardian_1,
        guardian_2,
        billing,
        role,
        primaryInsurance,
        secondaryInsurance,
        ...userInfo
      } = user;

      setCookieFn('userInfo', JSON.stringify(userInfo), {
        expires: expireDate,
        path: '/'
      });

      setCookieFn('spouse', JSON.stringify(spouse), {
        expires: expireDate,
        path: '/'
      });

      setCookieFn(
        'guardian',
        JSON.stringify({
          guardian_1,
          guardian_2
        }),
        {
          expires: expireDate,
          path: '/'
        }
      );

      setCookieFn('billing', JSON.stringify(billing), {
        expires: expireDate,
        path: '/'
      });

      setCookieFn('role', role, { expires: expireDate, path: '/' });

      setCookieFn('primaryInsurance', JSON.stringify(primaryInsurance), {
        expires: expireDate,
        path: '/'
      });

      setCookieFn('secondaryInsurance', JSON.stringify(secondaryInsurance), {
        expires: expireDate,
        path: '/'
      });

      sessionStorage.removeItem('guestSubmission');
      history.push(Routes.Dashboard);
    });
  } catch (err) {
    resetErrorMessage(err);
  }
};
